<template>
  <div>
    <Header>
      Edycja kontaktu
    </Header>

    <b-row>
      <b-col xl="6">
        <Errors/>

        <b-form @submit.prevent="submit">
          <b-form-group label="Nazwa:">
            <b-form-input
              v-model="form.name"
              :disabled="form.processing"
              required
            />
          </b-form-group>
          <b-form-group label="Telefon:">
            <b-form-input
              v-model="form.phoneNumber"
              :formatter="phoneFormatter"
              :state="isPhoneValid"
              :disabled="form.processing"
              required
            />
          </b-form-group>
          <b-form-group label="Email:">
            <b-form-input
              v-model="form.email"
              type="email"
              :state="isEmailValid"
              :disabled="form.processing"
            />
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('contacts.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
                <b-button variant="danger" @click="deleteContact">
                  <b-icon icon="trash"/>
                </b-button>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing">
                  <b-icon icon="check"/>
                  Zapisz
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from '@/Layouts/Components/Errors'
import EmailValidation from '@/Mixins/EmailValidation'
import _ from "lodash";

export default {
  components: {
    Header,
    Errors,
  },
  mixins: [EmailValidation],
  layout: Layout,
  props: {
    contact: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.contact.name || '',
        phoneNumber: this.contact.phone_number || '',
        email: this.contact.email || '',
      }),
      formDelete: this.$inertia.form({}),
    }
  },
  computed: {
    isPhoneValid() {
      const phone = this.form.phoneNumber.replace(/ /g, '')
      return phone.length === 9
    },
    isEmailValid() {
      return this.validateEmail(this.form.email);
    },
  },
  methods: {
    submit() {
      this.form
        .transform((data) => {
          data.phoneNumber = data.phoneNumber.replace(/ /g, '')
          return data
        })
        .put(this.route('contacts.update', this.contact.id))
    },
    async deleteContact() {
      const confirmation = await this.$bvModal.msgBoxConfirm(
        'Czy na pewno chcesz usunąć?',
        {
          title: 'Usuwanie',
          okVariant: 'danger',
          okTitle: 'Usuń',
          cancelTitle: 'Anuluj',
          cancelVariant: 'light',
          hideHeaderClose: false,
          centered: true,
        }
      )
      if (!confirmation) return

      this.formDelete.delete(this.route('contacts.destroy', this.contact.id))
    },
    phoneFormatter(val) {
      val = val.replace(/\D/g, '')
      if (val.startsWith('48') && val.length === 11) {
        val = val.replace('48', '')
      }
      val = val.match(/.{1,3}/g) || []
      return val.join(' ')
    },
  },
}
</script>
